import { computed, Ref, ref, watch } from "vue"
import { createDraggable } from 'animejs';
import { E_AiHelperEvent, E_AiHelperState } from "@/components/AiHelper.types";
import { usePermission } from "./usePermission";

export function useAi(hasLogin: Ref<boolean>) {
    const {
        $hasPerm,
    } = usePermission()


    // AI对话框    
    const aiHelperRef = ref(null)

    function fireEvent(event: E_AiHelperEvent) {
        aiHelperRef.value?.fireEvent(event)
    }

    const aiChatDialogVisible = ref(false)

    const openAiChat = () => {
        aiChatDialogVisible.value = true
    }

    function onCloseAiChat() {
        aiChatDialogVisible.value = false
        fireEvent(E_AiHelperEvent.ReActive)
    }

    const aiHelperClosed = ref(false)

    function onAiMenuClick() {
        if (aiHelperClosed.value) {
            aiHelperState.value = E_AiHelperState.Entry
            aiHelperClosed.value = false
        }
    }


    const showAIHelper = computed(() => {
        return $hasPerm('system:aiHelper') && hasLogin.value && !aiHelperClosed.value
    })

    watch(aiHelperRef, (comp) => {
        if (comp) {
            createDraggable(aiHelperRef.value.$el, {
                container: document.body,
                onDrag() {
                    fireEvent(E_AiHelperEvent.Drag)
                }
            });
        }
    })

    const aiHelperState = ref(E_AiHelperState.Entry)
    function onUpdateAiHelperState(state: E_AiHelperState) {
        aiHelperState.value = state
        if (state === E_AiHelperState.Closed) {
            aiHelperClosed.value = true
        }
    }

    return {
        aiHelperRef,
        openAiChat,
        onCloseAiChat,
        showAIHelper,
        aiChatDialogVisible,
        onAiMenuClick,
        aiHelperState,
        onUpdateAiHelperState,
    }
}